import * as Account from '../../Account/components/Account.css';

export default {
	Account
};
